export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: 'payment' | 'subscription';
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'medical-report-prompt-surgery',
    priceId: 'price_1SZaz94jiTni7pspn11MtvbR',
    name: 'Medical Report Prompt [Surgery Form]',
    description: 'Specialized surgical report template for comprehensive surgical documentation',
    price: 4.99,
    currency: 'gbp',
    mode: 'payment'
  },
  {
    id: 'medical-report-prompt',
    priceId: 'price_1SZV844jiTni7pspBd44voXd',
    name: 'Medical Report Prompt',
    description: 'Professional medical report template to enhance your medical practice',
    price: 4.99,
    currency: 'gbp',
    mode: 'payment'
  }
];

export const products = stripeProducts;

export const getProductById = (id: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.id === id);
};

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};